const { default: styled } = require('styled-components')

export const StyledSuggestions = styled.div``
